export const placeholderCardBig =
  "https://assets.myhubble.money/web-assets/image_placeholder_big.png";
